module.exports = __webpack_public_path__ + "img/01-images-01.00810042.png";